import {BaseModel, DisableModel} from 'model/base.model';
export interface ActiveUser extends BaseModel, DisableModel {
  linkPicture?: string;
  disabled?: boolean;
}

export const defaultActiveUser: Readonly<ActiveUser> = {
};
